/*
 * @file: 曝光
 */
import 'intersection-observer';
import {sendExposureLog} from './logger/exposure';
interface Options {
    root?: string;
    threshold?: number;
    rootMargin?: string;
}
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class Exposure {
    static instance: Exposure;

    private observer: IntersectionObserver | undefined;

    private readonly hasShowElementSet = new WeakSet();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    constructor(options?: Options) {
        if (!Exposure.instance) {
            Exposure.instance = this;
        }
        this.init(options);
        this.collectElements();
    }

    getInstance() {
        return Exposure.instance;
    }

    removeObserve() {
        this.observer && this.observer.disconnect();
        window.removeEventListener('scroll', this.scroll.bind(this), true);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    add(el: HTMLElement) {
        this.observer && this.observer.observe(el);
    }

    collectElements() {
        const showElements = document.querySelectorAll('[data-show]') as unknown as HTMLElement[] || [];
        showElements.forEach(ele => {
            this.add(ele);
        });
    }

    private scroll() {
        this.collectElements();
    }

    private init(options?: Options) {
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(item => {
                    const target = item.target as HTMLElement;
                    if (
                        item.intersectionRatio > 0
                        && item.isIntersecting
                        && !this.hasShowElementSet.has(target)
                    ) {
                        if (target?.dataset?.show) {
                            // 发送曝光日志
                            sendExposureLog(target);
                        }
                        this.hasShowElementSet.add(target);
                        // 取消元素监听
                        observer.unobserve(target);
                    }
                });
            },
            Object.assign(
                {
                    root: null,
                    threshold: 0.2,
                },
                options
            )
        );
        // @ts-ignore
        this.observer.USE_MUTATION_OBSERVER = true;
        // @ts-ignore
        this.observer.POLL_INTERVAL = 10;
        window.addEventListener('scroll', this.scroll.bind(this), true);
    }
}
